// @ts-check
import * as ReferralDashboard from './ReferralDashboard';
import * as Questionnaire from './Questionnaire';
import api from 'utils/api';

function validateAgent(formValues, dispatch) {
  return api
    .post('/guest_portal/api/agent_validations', { agent: { email: formValues.email } })
    .then(response => {
      if (response.data.errorCode === 'email_already_taken') {
        return Promise.reject({ email: 'already_taken' });
      }
      return null;
    });
}

export { validateAgent, ReferralDashboard, Questionnaire };
